import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const rocksdbKVSchema: Schema = {
  title: 'RocksDB KV',
  level: 3,
  columns: commonColumns
}
